export default __webpack_public_path__ + "static/Branson-821a3716f17e6e45b21aa3667422e8ec.png";